var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.link ? 'NuxtLink' : 'button',_vm._g(_vm._b({tag:"component",staticClass:"base-button",class:_setup.computedClasses,attrs:{"to":_vm.link,"aria-disabled":_vm.disabled}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }